import FilterControl from "./FilterControl"

const Filter = ({ config, selectedLabel, onApply, onClear }) => {
  return (
    <FilterControl
      config={config}
      selectedLabel={selectedLabel}
      onApply={onApply}
      onClear={onClear}
    />
  );
};

export default Filter
